
<template>
    <div>
        <Steps :current="formData.status"  class="bg-fff padding-top-15 padding-bottom-15" v-if="type==='query'">
            <Step  v-for="(val) of getStatus" :title="val.label" :key="val.value"></Step>
        </Steps>
        <div v-if="type=='query'" class="margin-top-10 margin-bottom-10">
            <vButton class="margin-right-10 light-content" @click="alertmodal('remark')">添加备注</vButton>
            
            <vButton class="margin-right-10" v-if="formData.status == 0 || formData.status == 8" theme="success" @click="alertmodal('audit')">提交审核</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 1" theme="warning" @click="alertmodal('pass')">通过审核</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 2 || formData.status == 9" theme="warning" @click="alertmodal('entryprice')">录入报价</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 3 || formData.status == 4 || formData.status == 5" theme="info" @click="alertmodal('submitprice')">报价确认</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 6" theme="success" @click="alertmodal('formalproduct')">转为正式产品</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 7" theme="warning" @click="alertmodal('queryinfor')">上架信息查看</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 3 || formData.status == 4 || formData.status == 5 || formData.status == 6 || formData.status == 7 || formData.status == 8 || formData.status == 9" theme="success" @click="alertmodal('queryprice')">查看报价</vButton>
            <vButton class="margin-right-10" v-if="formData.status == 3 || formData.status == 4 || formData.status == 5" theme="warning" @click="alertmodal('chosefactory')">选择打样工厂</vButton>

            <vButton class="margin-right-10" v-if="formData.status == 3 || formData.status == 4 || formData.status == 5 || formData.status == 6" theme="primary" @click="alertmodal('entryNews')">录入打样信息</vButton>
            <vButton class="margin-right-10" v-if="!(formData.status == 0 || formData.status == 10)" theme="info" @click="uploadImage('xiugai')">修改主图</vButton>
            
            <vButton v-if="type=='query'" theme="primary" class="margin-right-10" @click="adddocument">附件上传</vButton>
            <vButton class="margin-right-10 pull-right" v-if="formData.status == 1" @click="alertmodal('rejected')">审核驳回</vButton>
        </div>
        <compWrapper title="新品预选" theme="primary">

            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="130"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="supplierEditForm"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="130"
            />
            <template v-if="type!='query'" slot="footer">
                <vButton class="margin-right-20" theme="info" @click="submit('caogao')">保存为草稿</vButton>
				<vButton class="margin-right-20" theme="primary" @click="submit">保存并提交</vButton>
				<vButton class="margin-right-20" @click="cancel">取消</vButton>
			</template>
        </compWrapper>
        <compWrapper title="附件" theme="success">
            <vButton v-if="type!='query'" theme="primary" class="margin-top-10 margin-left-20" @click="adddocument">附件上传</vButton>
            <vTable
                class="margin-20"
				:columns="doccolumns" 
				:data="docList"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <compWrapper title="报告" theme="warning" v-if="datalist.length>0">
            <vTable
                v-for="(item,index) in datalist"
                :key="index"
                class="margin-15"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="getRequestData(item,index).length>0 && item.attachMeta!=null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
            <vTable
                v-for="(item,index) in datalist"
                :key="index"
                class="margin-15"
				:columns="baogaocolumns" 
				:data="getRequestData(item,index)"
                v-show="item.attachMeta===null ? true:false"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <compWrapper title="报价记录" theme="info" v-if="type=='query'">
            <div class="margin-left-20 inbound-info" >
                <span>报价状态: {{choseConmpy.status == 2 ? '已确认报价':''}}</span>
                <span>选中供应商: {{choseConmpy.companyName}}</span>
                <span><vButton @click="alertmodal('queryprice')">查看详情</vButton></span>
            </div>
            <vTable
                class="margin-20"
				:columns="baojiacolumns" 
				:data="datalist"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <!-- 关联ERPSKU -->
        <compWrapper title="关联ERPSKU" theme="warning" v-if="type=='query'">
            <vTable
                class="margin-20"
				:columns="erpskucolumns" 
				:data="erpskulist"
				size="small" 
				ref="erpskutable"  
				border
            ></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>

        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" @on-close="closemodalprops"></component>
        </compModal>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpGetPrimaryOne, HttpSavePrimaryOne, HttpCheckPrimary, HttpSubmitPrimary, HttpGetRecommendOne, HttpRemarkPrimary, HttpPrimaryPreCoding, HttpGetOfferList, HttpUploadPrimaryAttach, HttpQueryErpsku, HttpSavePic } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts'
import { HttpDelAttach, HttpDelAttachNew } from "@/service/purchase/purchase";

import { HttpSysOpLog } from '@/service/boss/allot';
import compRecommend from './alert/recommend';

import compEntryprice from './alert/entryprice';
import compSubmitprice from './alert/submitprice';

import compStoreinformation from './alert/storeinformation';
import compProofing from './alert/proofing';
import compChangeproduct from './alert/changeproduct';
import compMaxImage from './alert/maximage';


import mixin from '../mixins'
// 搜索品类
import searchCategory from "../../products/searchcategory/index";

export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            recommId: this.$route.query.recommendid || 0,
            formData:{
                currency:'USD'
            },
            logList:[],
            docList:[],
            baogaoList:[],
            datalist:[],
            modalProps:{},
            loading:false,
            categoryList:[],
            downcateoryList:[],
            erpskulist:[],
            choseConmpy:{
                status:0,
                companyName:'',
            },
            titleName:'',
        }
    },
    created(){
        this.getcategory();
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compRecommend,
        compEntryprice,
        compSubmitprice,
        compStoreinformation,
        compProofing,
        compChangeproduct,
        searchCategory,
        compMaxImage,

	},
    computed:{
        ...mapGetters('diction',['getNewProductList','getAllCurrency']),
        ...mapState('boss', ['accountTypes']),
        getStatus(){
            let array;
            if (this.formData.status === 10) {
                array = [
                    { value: 10, label: this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'}) },
                ]
            }else {
                array = this.getPrimaryStatus.concat().splice(0,8)
            }
            return array
        },
        getBase(){
            return [
                {
					label: "产品主图",
					key: "pictureUrl",
                    tag: "img",
                    span:6,
                    props:{
                        style:"height:70px;",
                        src:this.formData.pictureUrl ? this.formData.pictureUrl : 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1599645172165&di=b13a3514d4c7c3c8f5da1c03e6574402&imgtype=0&src=http%3A%2F%2Fimages.669pic.com%2Felement_pic%2F3%2F88%2F77%2F52%2F63160fa6edcfde1b73bafadf9be77e8d.jpg'
                    },
                    show:this.type !='query',
                    
                },
                {
                    labelWidth:0,
                    span:6,
                    tag: "div",
                    props:{
                        style:"height:85px;",
                    },
                    children: (h) => {
						return <vButton nativeOnClick={this.uploadImage.bind(this)}>上传图片</vButton>
					},
					show:this.type !='query'
                },
                {
					label: "产品主图",
					// key: "pictureUrl",
                    tag: "div",
                    span:12,
                    render: (h, props) => {
                        if(this.formData.pictureUrl){
                            return <a onClick={this.clickMaximage.bind(this)}><img src={this.formData.pictureUrl} style="height:70px;"/></a>
                        }else {
                            return <img src='https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1599645172165&di=b13a3514d4c7c3c8f5da1c03e6574402&imgtype=0&src=http%3A%2F%2Fimages.669pic.com%2Felement_pic%2F3%2F88%2F77%2F52%2F63160fa6edcfde1b73bafadf9be77e8d.jpg' style="height:70px;"/>
                        }
                    },
                    show:this.type =='query'
                },
                {
					label: "预编码",
					key: "precoding",
                    tag: "vInput",
                    required:false
                },
                {
					label: "状态",
					key: "status",
                    tag: "vSelect",
                    options:this.getPrimaryStatus,
                    show:this.type=='query'
                },
                {
					label: "关联推荐",
					key: "recommendName",
                    tag: "vInput",
                    children: (h) => {
						return <vIcon
							type="search"
							slot="suffix"
							size="18"
							class="margin-right-5"
							nativeOnClick={this.handleRecoomendModal}
						/>
                    },
                    props:{
                        readonly:true,
                    }
                },
                {
					label: "产品标题",
					key: "title",
                    tag: "vInput",
                    span:24,
                },
                {
					label: "来源",
					key: "source",
                    tag: "vSelect",
                    options:[
                        {value:'MP',label:'MP'},
                        {value:'BU',label:'BU'},
                        {value:'Sourcing',label:'Sourcing'},
                        {value:'Other',label:'Other'},
                    ],
                },
                {
					label: "目标站点",
					key: "targetSite",
                    tag: "Select",
                    options: this.accountTypes.map(item=>{
                        return {
							value: item.name,
							label: item.name
						}
                    }),
					props: {
                        filterable: true,
                        multiple: true
                    },
                    required: false,
                    
                },
                {
					label: "推荐类型",
					key: "recommendType",
                    tag: "vSelect",
                    options: [
                        {value:0,label:'纯新品'},
                        {value:1,label:'老品拓展'},
                    ],
                    props: {
						filterable: true,
                    },
					query: true,
                },
                {
                    label: "品类",
                    span:24,
                    key: "categoryName",
                    // children: (h) => {
					// 	return <vIcon
					// 		title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
					// 		type="search"
					// 		center
					// 		slot="suffix"
					// 		style="padding:6px;pointer-events: initial;"
					// 		size="18"
					// 		nativeOnClick={this.handleModalplat.bind(this)}
					// 	/>
					// },
					// props: {
                    //     readonly: true,
                    //     placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'})
                    // },
                    query:true,
                    show:this.type != 'query'
                },
                {
                    label: "品类",
                    span:24,
					key: "categoryId",
                    tag: "Select",
                    options: this.downcateoryList.map(item=>{
                        return {
                            value:item.id,
                            label:item.code+'-'+item.name
                        }
                    }),
                    required: false,
                    show:this.type == 'query'
				},
                

                // 单独品类
				{
					span:24,
					show:this.type!='query',
					valueText:this.titleName,
					query:true,
                },
                {
					span:24,
					show:this.type=='query',
					valueText:this.formData.categoryCodeName,
					query:true,
                },
                
                {
					label: "项目",
                    key: "lineId",
                    tag: "Select",
                    options: this.getNewProductList,
					props: {
						filterable: true,
                    },
                    formItem: {
						tip: this.type == 'query' ? '' : '<div class="color-error">项目未确定或还未立项目时，可不填</div>',
                    },
                    on:{
                        'on-change':(val)=>{
                            let oneLine = this.getNewProductList.filter(item=>{return val === item.value})[0]
                            this.formData.department = oneLine.attach.nickname;
                        }
                    },
                    required: false,
                },
                {
					label: "所属部门",
                    key: "department",
                    tag: "Input",
                    required: false,
                },
                {
					label: "期望FOB（USD）",
					key: "expectFob",
					tag: "vInputNumber",
                },
                {
					label: "主材质",
					key: "mainMaterial",
					tag: "vInput",
                },
                {
					label: "竞品链接",
					key: "competitiveLink",
                    tag: "vTextarea",
                    props:{
                        placeholder:"输入多个，一行一个",
                    },
                    show:this.type!='query'
                },
                {
					label: "竞品链接",
					key: "competitiveLink",
                    tag: "div",
                    show:this.type=='query',
                    render:(h)=>{
                        let competitiveArr= (this.formData.competitiveLink || '').split(",");
                        return competitiveArr.map(item=>{
                            return <div style="word-wrap:break-word; word-break:break-all;overflow: hidden;"><a href={item} target="_blank">{item}</a></div>
                        })
                    }
                },
                
                {
					label: "产品属性",
					key: "property",
                    tag: "vTextarea",
                    required: false,
                },
                {
					label: "Key Feature",
					key: "keyFeature",
                    tag: "vTextarea",
                    required: false,
                },
                
                
                {
					label: '展开尺寸（inch）',
					span:12,
					valueText:(this.formData.length?this.formData.length:'--')+" * "+(this.formData.width?this.formData.width:'--')+" * "+(this.formData.height?this.formData.height:'--'),
					show:this.type =='query'
				},
                {
					label: "展开尺寸（inch）",
					key: "length",
                    span:5.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
					show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "width",
                    span:3.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
					show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "height",
                    span:3,
					tag: "vInputNumber",
                    props:{
                        placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
					show:this.type !='query'
                },
                {
					label: '包装尺寸（inch）',
					span:12,
					valueText:(this.formData.packageLength?this.formData.packageLength:'--')+" * "+(this.formData.packageWidth?this.formData.packageWidth:'--')+" * "+(this.formData.packageHeight?this.formData.packageHeight:'--'),
					show:this.type =='query'
				},
                {
					label: "包装尺寸（inch）",
                    key: "address",
                    key: "packageLength",
                    span:5.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
                    show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "packageWidth",
                    span:3.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
					show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "packageHeight",
                    span:3,
					tag: "vInputNumber",
                    props:{
                        placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required: false,
					show:this.type !='query'
                },
                
                {
					label: "产品毛重（lbs）",
					key: "weight",
                    tag: "vInputNumber",
                    required: false,
                },
                {
					label: '目标售价',
					span:12,
					valueText:(this.formData.targetPrice?this.formData.targetPrice:'--')+" "+(this.formData.currency?this.formData.currency:'--'),
					show:this.type =='query'
				},
                {
					label: "目标售价",
					key: "targetPrice",
                    tag: "vInputNumber",
                    span:9,
                    required: false,
                    show:this.type !='query'
                },
                {
                    labelWidth:0,
                    key: "currency",
                    span:3,
                    tag: "Select",
                    options:this.getAllCurrency,
                    required: false,
					show:this.type !='query'
                },
                {
					label: "预估销量",
					key: "estimatedSalesVolume",
                    tag: "vInputNumber",
                    required: false,
                },
                {
					label: "预估销售额（USD）",
					key: "estimatedSales",
                    tag: "vInputNumber",
                    required: false,
                },
                
                {
					label: "备注",
					key: "remark",
                    tag: "vTextarea",
                    required: false,
                },
                {
					label: "取消原因",
					key: "cancelReason",
                    tag: "vTextarea",
                    required:false,
                    show:this.formData.status == 10
                },
                {
					label: "提交人",
					key: "submitterName",
                    tag: "vInput",
                    show:this.type=='query'
                },
                
            ]
        },
        doccolumns(){
            let _this = this
            return [
				{
					title: '附件名称',
                    key: 'attachTitle',
                    render:(h,{row})=>{
                        return <a href={row.attachUrl} target="_blank">{row.attachTitle}</a>
                    }
                }, 
                {
					title: '操作时间',
                    key: 'attachOpAt'
                },
                {
					title: '操作人',
                    key: 'createdName'
                },
				{
					title: '操作',
                    // width: 120,
                    render(h, { row, index }) {
                        let delButton = ''
                        if (_this.type !== 'query') {
                            delButton = h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        _this.remove(index)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        }
						return h('div', [
							delButton,
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
        baogaocolumns(){
            let _this = this
            return [
				{
					title: '报告名称',
                    key: 'attachTitle',
                    render:(h,{row})=>{
                        return <a href={row.attachUrl} target="_blank">{row.attachTitle}</a>
                    }
                }, 
                {
					title: '操作时间',
                    key: 'attachOpAt'
                },
                {
					title: '操作人',
                    key: 'createdName'
                },
				{
					title: '操作',
                    // width: 120,
                    render(h, { row, index }) {
                        let delButton = ''
                        if (_this.type !== 'query') {
                            delButton = h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        _this.remove(index)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        }
						return h('div', [
							delButton,
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
        baojiacolumns(){
            return [
                {
					title: '报价公司名称',
					key: 'companyName',
                }, 
                {
					title: '生产提前期（天）',
					key: 'productionCycle',
                }, 
                {
					title: '最小起订量',
					key: 'minOrderQty',
                }, 
                {
					title: '报价（USD）',
					key: 'offerUsd',
                }, 
                {
					title: '报价（CNY）',
					key: 'offerCny',
                }, 
                {
					title: '备注',
					key: 'remark',
                }, 
                {
                    title: '是否选中',
                    key: "status",
                    render:(h,{row})=>{
                        return <div>{row.status == 2 ? '是' : '否'}</div>
                    }
                }, 
            ]
        },
        erpskucolumns(){
            return [
                {
					title: 'ERPSKU',
					key: 'erpSku',
                }, 
                {
					title: '备注',
					key: 'remark',
                }, 
            ]
        },
    },
    methods:{
        getRequestData(item,index){
            if(item.attachMeta){
                let arraylist = JSON.parse(item.attachMeta).items;
                arraylist.map(jsonone=>{
                //   console.log(jsonone)
                  jsonone.orderid = item.id
                })

                // console.log(arraylist)
                return arraylist
            }else{
                return []
            }
        },
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
        getcategory(){
            HttpGetCategories().then(res=>{
                this.categoryList = res.data;
                this.downcateoryList = res.data.filter(item=>{
                    return item.level == 3
                })
                this.update();
            })
        },
        // 上传图片
        uploadImage(types){
            // let _this = this;
            this.modalProps = {
                show: true,
                title: '上传图片',
                width:460,
                showFooter: false,
                action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentPreselection/uploadPic",
                name: "uploadPic",
                component: "compUpload",
                on:{
                    'on-success':(res)=>{
                        // console.log(types)
                        if(types == 'xiugai'){
                            HttpSavePic({
                                id:this.id,
                                pic:res.message
                            }).then(res=>{
                                this.$VMessage.success(res.message);
                                this.update();
                                // this.$emit('on-update');
                                this.$emit('on-current-page-update');
                            })
                        }else{
                            this.$set(this.formData,'pictureUrl',res.message);
                        }
                        this.modalProps = {}
                    }
                }
            }
        },
        clickMaximage(){
            // console.log(234234234)
            this.modalProps = {
                show: true,
                title:'查看图片',
                width: 460,
                component: "compMaxImage",
                imagurl:this.formData.pictureUrl,
                showFooter:false
            };
        },
        handleRecoomendModal(){
            this.modalProps = {
                show: true,
                title: '关联推荐',
                width: 1000,
                component: "compRecommend",
                showFooter: false,
                on:{
                    'on-data':(row)=>{
                        console.log(row)
                        this.$set(this.formData,'recommendName',row.title + ' ('+row.id+')');
                        this.$set(this.formData,'recommendId',row.id);
                        this.$set(this.formData,'categoryId',row.categoryId);
                        this.$set(this.formData,'lineId',row.lineId);
                        this.$set(this.formData,'source',row.source);
                        this.$set(this.formData,'targetSite',(row.targetSite || '').split(','));
                        this.$set(this.formData,'competitiveLink',row.competitiveLink);
                        this.$set(this.formData,'department',row.department);
                        this.$set(this.formData,'recommendType',row.recommendType);
                        this.$set(this.formData,'remark',row.remark);

                        let cateone = this.downcateoryList.filter(item=>{
                            return item.id == row.categoryId;
                        })[0] || {};
                        
                        this.$set(this.formData,'categoryName',cateone.code ? cateone.code+'-'+cateone.name : '');

                        this.$set(this.$data,'titleName',row.categoryCodeName)

                        this.modalProps={}
                    },
                    'on-cancel':()=>{
                        this.modalProps={}
                    }
                },
			};
        },
        handleModalplat(){
            this.modalProps = {
                title:'搜索品类',
                show:true,
                width:650,
                component: "searchCategory",
                showFooter:false,
                on:{
                    'on-chosedata':(data)=>{
                        // console.log(data)
                        this.$set(this.formData,'categoryName',data.code+'-'+data.name);
                        this.$set(this.formData,'categoryId',data.id);


                        // 品类获取
                        let array = this.getParentItem(data.id);
                        let newarr = []
                        console.log(array)
                        for(var i = array.length-1;i>=0;i--){
                            newarr.push(array[i])
                        }
                        let title = newarr[1].name + "/" + newarr[2].name + "/" + newarr[3].name;
                        // console.log(title,'545454')
                        this.$set(this.$data,'titleName',title);
                        this.modalProps = {}
                    }
                }
            }
        },
        downfile(url){
            this.handleWebfs(url, {}, 'download')
        },
        adddocument(){
            this.modalProps = {
                show: true,
                title: '添加附件',
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: 'pd_preselection',
                    type: 'other',
                },
                showFooter: false,
                action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                name: "multipartFile",
                multiple: true,
                on:{
                    'on-success':(res)=>{
                        console.log(this.docList.length)
                        let flag = false
                        if ((res.items.length + this.docList.length) > 5) {
                            this.$VMessage.error('附件数量过多，请打包后上传')
                            flag = true
                        }
                        res.items.map((item) => {
                            if (flag) {
                                this.remove(item.attachId, true)
                            }
                            else {
                                this.docList.push(item)
                            }
                        })
                        if(this.type == 'query'){
                            this.succesUpload()
                        }
                        this.modalProps={}
                    },
                    'on-cancel':()=>{
                        this.modalProps={}
                    }
                },
			};
        },
        remove (index) {
            // 新增时删除附件用另外的接口
            if (this.type === 'add') {
                HttpDelAttachNew({
                    id: useId ? index : this.docList[index].attachId
                }).then(res => {
                    if (!useId) {   
                        this.docList.splice(index, 1)
                        this.$VMessage.success(res.message)
                    }
                }, err => {
                    if (!useId) {
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    }
                })
            }
            // 编辑
            else {
                this.docList.splice(index, 1)
                HttpUploadPrimaryAttach({
                    preselectionId: this.id || 0,
                    attach: JSON.stringify({
                        items: this.docList,
                        opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                        organizationId: global.SYSID
                    }),
                }).then(res => {
                    this.$VMessage.success(res.message)
                }, err => {
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                })
            }
        },
        succesUpload(){
            HttpUploadPrimaryAttach({
                preselectionId: this.id || 0,
                attach: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                    organizationId: global.SYSID
                }),
            }).then(res => {
                this.$VMessage.success(res.message)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        update(){
            if(this.type == 'add'){
                HttpPrimaryPreCoding().then(res=>{
                    this.$set(this.formData,'precoding',res.message)
                });
                // 请求单条的关联推荐
                HttpGetRecommendOne({
                    id:this.recommId,
                }).then(res=>{
                    // this.$set(this.formData,'recommendName',res.data.title)
                    this.$set(this.formData,'recommendName',res.data.title + ' ('+res.data.id+')');
                    this.$set(this.formData,'recommendId',res.data.id);
                    this.$set(this.formData,'categoryId',res.data.categoryId);
                    this.$set(this.formData,'lineId',res.data.lineId);
                    this.$set(this.formData,'source',res.data.source);
                    this.$set(this.formData,'targetSite',(res.data.targetSite || '').split(','));
                    this.$set(this.formData,'competitiveLink',res.data.competitiveLink);
                    this.$set(this.formData,'department',res.data.department);
                    this.$set(this.formData,'recommendType',res.data.recommendType);
                    this.$set(this.formData,'remark',res.data.remark);
                    

                    let cateone = this.downcateoryList.filter(item=>{
                        return item.id == res.data.categoryId;
                    })[0] || {};
                    
                    this.$set(this.formData,'categoryName',cateone.code ? cateone.code+'-'+cateone.name : '');


                    this.$set(this.$data,'titleName',res.data.categoryCodeName)
                })
                return
            } 
                
            // 日志
            if(this.type == 'query'){
                HttpSysOpLog({
                    'search[EQ_opDataId]':this.id,
                    'search[EQ_opModel]':'Product_Development_Preselection',
                    row:1000,
                    page:1,
                }).then(res=>{
                    this.logList = res.data.content
                },err=>{
                    this.errorMessage(err.message);
                })
                HttpGetOfferList({
                    'search[EQ_preselectionId]':this.id,
                    row:20,
                    page:1,
                }).then(res=>{
                    this.datalist = res.data.content
                    let one = this.datalist.filter(item=>{
                        return item.status == 2
                    })[0] || {}
                    console.log(this.datalist)
                    
                    this.choseConmpy = one
                })
                HttpQueryErpsku({
                    preselectionId:this.id,
                }).then(res=>{
                    this.erpskulist = res.data;
                })
            }
            this.loading = true;
            let _this = this;
            HttpGetPrimaryOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.docList = res.data.attachMeta ? JSON.parse(res.data.attachMeta).items : [];
                if(this.type !='query'){
                    this.formData.targetSite = (res.data.targetSite || '').split(',');
                }
                this.titleName = res.data.categoryCodeName;
                let cateone = this.downcateoryList.filter(item=>{
                    return item.id == res.data.categoryId;
                })[0] || {};
                
                this.$set(this.formData,'categoryName',cateone.code ? cateone.code+'-'+cateone.name : '');
                
                // 请求单条的关联推荐
                HttpGetRecommendOne({
                    id:res.data.recommendId
                }).then(res=>{
                    this.$set(this.formData,'recommendName',res.data.title + ' ('+res.data.id+')')
                })
                this.loading = false;
            },err=>{
                this.errorMessage(err.message);
                this.loading = false;
            })
        },
        getParentItem(parentId,result=[]){
			let parent = this.categoryList.find(val=> val.id == parentId)
			if(parent){
				result.push(parent)
			}
			if(parent && parent.parentId){
				this.getParentItem(parent.parentId,result)
			}
			return result

		},
        async submit(typesta){
            let flag = false
            await this.$refs.supplierEditForm.validate(valid => {
                if (!valid) return flag = true
            })
            if (flag) return this.$VMessage.error('请填写必填项')
            
            if(!this.formData.pictureUrl){
                this.$VMessage.error('请上传产品主图');
                return;
            }

            if(this.formData.competitiveLink!=''){
                if(!(this.formData.competitiveLink instanceof Array)){
                    this.formData.competitiveLink = this.formData.competitiveLink.replace(/\n/g,",");
                }
            }
            let arrayLink = this.formData.competitiveLink.split(",");
            let titleLine = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
            let falgLink = false;
            arrayLink.map(item=>{
                if(titleLine.test(item)===false){
                    falgLink = true;
                }
            })

            if(falgLink){
                this.$VMessage.error('竞品链接输入请以http/https开头');
                return;
            }

            this.loading = true;

            let onestatus = typesta == 'caogao' ? 0 : 1
            HttpSavePrimaryOne({
                orgId:global.SYSID,
                ...this.formData,
                categoryCodeName:this.titleName,
                targetSite: (this.formData.targetSite || []).join(','),
                attachMeta: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                    organizationId: global.SYSID
                }),
                status:onestatus,
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel()
                this.loading = false;
            },err=>{
                this.errorMessage(err.message);
                this.loading = false;
            })
        },
        
        cancel(){
            this.$router.push({
                name: 'primaryList',
            })
        },
        alertmodal(type){
            let datajson = {
                orderid:this.id,
                precoding:this.formData.precoding,
                orderstatus:this.formData.status,
            }
            switch(type){
                case 'remark':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: "添加备注",
                        width: 460,
                        showDesc:false,
                        params:{id:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注原因",
                            }
                        ],
                        ajaxRequest:HttpRemarkPrimary,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'audit':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: "提交审核",
                        width: 460,
                        showDesc:false,
                        params:{ids:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpSubmitPrimary,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'pass':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "warning",
                        title: "审核通过",
                        width: 460,
                        showDesc:false,
                        params:{statusId:2,ids:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpCheckPrimary,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'rejected':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: "审核驳回",
                        width: 460,
                        showDesc:false,
                        params:{statusId:8,ids:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                            }
                        ],
                        ajaxRequest:HttpCheckPrimary,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'entryprice':
                    this.$emit('on-closeCloseable');
                    let pricedata = {
                        orderid:this.id,
                        precoding:this.formData.precoding,
                        orderstatus:this.formData.status,
                        submitterName:this.formData.submitterName,
                        submitTime:this.formData.submitTime,
                        docList:this.docList,
                    }
                    this.modalProps = {
                        title:'录入报价',
                        show:true,
                        width:1000,
                        component: "compEntryprice",
                        entrydata:pricedata,
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                // this.$emit('on-update');
                                this.$emit('on-current-page-update');
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'submitprice':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        title:'报价确认',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'submitoffer',
                        showFooter:false,
                        showDocList:true,
                        on:{
                            'on-update':()=>{
                                this.update();
                                // this.$emit('on-update');
                                this.$emit('on-current-page-update');
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'queryprice':
                    this.$emit('on-closeCloseable');
                    let subdata = {
                        orderid:this.id,
                        precoding:this.formData.precoding,
                        orderstatus:this.formData.status,
                        submitterName:this.formData.submitterName,
                        submitTime:this.formData.submitTime,
                        bidderName:this.formData.bidderName,
                        offerTime:this.formData.offerTime,
                        reviewerName:this.formData.reviewerName,
                        approvedTime:this.formData.approvedTime,
                        checkOfferName:this.formData.checkOfferName,
                        checkOfferTime:this.formData.checkOfferTime,
                        docListdata:this.docList
                    }
                    this.modalProps = {
                        title:'报价查看',
                        show:true,
                        width:1000,
                        component: "compSubmitprice",
                        entrydata:subdata,
                        querytype:'query',
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'formalproduct':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        title:'转为正式产品',
                        show:true,
                        width:600,
                        component: "compChangeproduct",
                        entrydata:this.id,
                        lineid:this.formData.lineId,
                        showFooter:false,
                        on:{
                            'on-close':()=>{
                                this.$emit('on-close')
                            }
                        }
                    }
                    break;
                case 'queryinfor':
                    this.$emit('on-closeCloseable');
                    let erparr = [];
                    this.erpskulist.map(item=>{
                        erparr.push(item.erpSku)
                    })
                    let storedata = {
                        orderid:this.id,
                        orderstatus:this.formData.status,
                        precoding:this.formData.precoding,
                        lineId:this.formData.lineId,
                        erplist:erparr,
                    }
                    this.modalProps = {
                        title:'上架信息查看',
                        show:true,
                        width:1000,
                        component: "compStoreinformation",
                        entrydata:storedata,
                        showFooter:false,
                        on:{
                            'on-close':()=>{
                                this.$emit('on-close')
                            }
                        }
                    }
                    break;
                case 'chosefactory':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        title:'选择打样工厂',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'chosefactory',
                        showFooter:false,
                        showDocList:true,
                        on:{
                            'on-update':()=>{
                                this.update();
                                // this.$emit('on-update');
                                this.$emit('on-current-page-update');
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
                case 'entryNews':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        title:'录入打样信息',
                        show:true,
                        width:1000,
                        component: "compProofing",
                        querydata:datajson,
                        querytype:'entrynews',
                        showFooter:false,
                        showDocList:false,
                        on:{
                            'on-update':()=>{
                                this.update();
                                // this.$emit('on-update');
                                this.$emit('on-current-page-update');
                                this.modalProps.show = false;
                            }
                        }
                    }
                    break;
            }
        },
    }
}
</script>
